var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    _vm.tag,
    {
      tag: "component",
      staticClass: "m-0 font-weight-bold",
      class: _vm.colorClass,
    },
    [
      _c(
        "span",
        [
          _vm._v(_vm._s(_vm.text)),
          _vm.additionalText
            ? [_vm._v(": " + _vm._s(_vm.additionalText))]
            : _vm._e(),
        ],
        2
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }